import { formatMetric } from '../panelConfig';

const PLATFORM_LABELS = { meta_ads: 'Meta', google_ads: 'Google' };

/** Desglose por plataforma de pauta (lead-gen): inversión, alcance y CPL. */
export default function PlatformTable({ platforms }) {
  return (
    <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
      <h3 className="mb-3 text-sm font-semibold text-gray-700">Rendimiento por plataforma</h3>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-gray-200 text-left text-xs uppercase tracking-wide text-gray-500">
              <th className="py-2 pr-3 font-medium">Plataforma</th>
              <th className="py-2 pr-3 text-right font-medium">Inversión</th>
              <th className="py-2 pr-3 text-right font-medium">Impresiones</th>
              <th className="py-2 pr-3 text-right font-medium">Clicks</th>
              <th className="py-2 pr-3 text-right font-medium">CPC</th>
              <th className="py-2 pr-3 text-right font-medium">CTR</th>
              <th className="py-2 pr-3 text-right font-medium">Leads</th>
              <th className="py-2 text-right font-medium">CPL</th>
            </tr>
          </thead>
          <tbody>
            {platforms.map((p) => (
              <tr key={p.platform} className="border-b border-gray-100 last:border-0">
                <td className="py-2 pr-3 text-gray-900">
                  {PLATFORM_LABELS[p.platform] || p.platform}
                </td>
                <td className="py-2 pr-3 text-right text-gray-700">{formatMetric(p.spend, 'currency')}</td>
                <td className="py-2 pr-3 text-right text-gray-700">{formatMetric(p.impressions, 'number')}</td>
                <td className="py-2 pr-3 text-right text-gray-700">{formatMetric(p.clicks, 'number')}</td>
                <td className="py-2 pr-3 text-right text-gray-700">{formatMetric(p.cpc, 'currency')}</td>
                <td className="py-2 pr-3 text-right text-gray-700">{formatMetric(p.ctr, 'percent')}</td>
                <td className="py-2 pr-3 text-right text-gray-700">{formatMetric(p.leads, 'number')}</td>
                <td className="py-2 text-right text-gray-700">{formatMetric(p.cpl, 'currency')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
